import React from "react";
import { usePhotoUploadError } from "./usePhotoUploadError";
import { PhotoUploadErrors } from "../../../../photoUploadErrors";
import wifiSymbol from "../../../../images/icon--wifiConnectivityRed.svg";

export const PhotoUploadError = () => {
  const { errorContent } = usePhotoUploadError();
  const { heading, subheading, advice, imageClass, errorType } = errorContent;
  return (
    <div className="ch-text--center ch-pt--2">
      {PhotoUploadErrors.OFFLINE === errorType ? (
        <img alt="wifi symbol" src={wifiSymbol} className="ch-mb--3" />
      ) : (
        <div className={`upload-error--${imageClass} ch-mb--3`} />
      )}
      <h2 className="ch-mb--3 ch-fs--4">{heading}</h2>
      {subheading && <p className="ch-mb--3 ch-fs--3">{subheading}</p>}
      <p className="ch-fs--3">{advice}</p>
    </div>
  );
};
